
import * as React from "react";
import {t} from "i18next";

import {Step, Icon, Table, Label, Flag, Segment} from "semantic-ui-react";
import {OptionTextDto, OptionDto} from "src/services/Client";
import PromtFormatter from "src/components/Table/components/reactQuill/PromtFormatter";

export enum StepTab {
    InitTab = 0,
    SummaryTab = 1,
    ConfirmTab = 2,
    ResultTab = 3
}

export enum SelectAction {
    SingleSelect = 0,
    SelectAll = 1,
    DeselectAll = 2
}

interface StepHeaderProps {
    activeTab: StepTab;
}

interface AMTBTransferErrorTableProps {
    result: {[key: number]: string};
    items: OptionDto[];
}

export const StepHeader = (props: StepHeaderProps) => (
    <Step.Group size={'mini'} className={'width--100Percent'}>
        <Step active={props.activeTab === StepTab.InitTab}>
            <Icon name={'pencil'} />
            <Step.Content>
                <Step.Title>{t("AMTB_TRANSFER:SELECT_MTB_TT")}</Step.Title>
            </Step.Content>
        </Step>

        <Step active={props.activeTab === StepTab.SummaryTab}>
            <Icon name={'tasks'} />
            <Step.Content>
                <Step.Title>{t("AMTB_TRANSFER:SELECT_ITEMS_TT")}</Step.Title>
            </Step.Content>
        </Step>

        <Step active={props.activeTab === StepTab.ConfirmTab}>
            <Icon name={'checkmark'} />
            <Step.Content>
                <Step.Title>{t("AMTB_TRANSFER:CONFIRM_TRANSFER_TT")}</Step.Title>
            </Step.Content>
        </Step>
        <Step active={props.activeTab === StepTab.ResultTab}>
            <Icon name={'info'} />
            <Step.Content>
                <Step.Title>{t("AMTB_TRANSFER:TRANSFER_RESULT_TT")}</Step.Title>
            </Step.Content>
        </Step>
    </Step.Group>
);

export const AMTBTransferErrorTable = (props: AMTBTransferErrorTableProps) => (
    <>
        <p style={{marginBottom: '10px', color: 'red'}}><b>{Object.keys(props.result).length + ' '}</b> {t("AMTB_TRANSFER:RESULT_ERROR")}</p>
        <Table
            celled={true}
            structured={true}
            className={"text-align--center"}
        >
            <Table.Header>
                <Table.Row>
                    <Table.HeaderCell>{t("AMTB_TRANSFER:OPTION_IDENTIFIER")}</Table.HeaderCell>
                    <Table.HeaderCell>{t("AMTB_TRANSFER:SHORTTEXT")}</Table.HeaderCell>
                    <Table.HeaderCell>{t("AMTB_TRANSFER:ERROR_MSG")}</Table.HeaderCell>
                </Table.Row>
            </Table.Header>
            <Table.Body>
                {Object.keys(props.result).map( (key: string, index: number)=> {
                    const dto = props.items.find((a) => a.objectId.toString() === key);

                    return (
                        <Table.Row key={'row-' + index}>
                            <Table.Cell>
                                <Label size={'large'} className={'whitespace--nowrap'}>
                                    {
                                        // @ts-ignore
                                        dto.optionBasic.optionCode
                                    }
                                    <Label.Detail>
                                        {
                                            // @ts-ignore
                                            dto.optionBasic.optionType
                                        }
                                    </Label.Detail>
                                </Label>
                            </Table.Cell>
                            <Table.Cell>
                                <Segment.Group horizontal={true}>
                                    {
                                        // @ts-ignore
                                        dto.texts.sort((a, b) =>
                                            (a.language && b.language && a.language.code && b.language.code && a.language.code > b.language.code) ? 1 : -1)
                                            .map((txt: OptionTextDto, idx: number) =>
                                                <Segment
                                                    key={"txt-" + idx}
                                                    className={'amtb-transfer-text-segment'}
                                                >
                                                    <Flag
                                                        name={txt.language && txt.language.code === "de" ? "de" : "gb"}
                                                        className={'amtb-transfer-text-flag'}
                                                    />
                                                    {txt.shorttext || ""}
                                                </Segment>
                                            )}
                                </Segment.Group>
                            </Table.Cell>
                            <Table.Cell>
                                {props.result[key]}
                            </Table.Cell>
                        </Table.Row>
                    );
                })}
            </Table.Body>
        </Table>
    </>
);



// WEBPACK FOOTER //
// ./src/views/OptionsView/amtbTransfer/AMTBTransferUtils.tsx